//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../no/Object.js";
import "../no/SubdivisionMeshBodyTopologyData.js";
import "../Features/Features.Subdivision.SubdivisionBodyCollection.js";
let d=[[],[[[],"NewMeshBodyTopoData",{R_:{meshTopoData:"SubdivisionMeshBodyTopologyData"}},0,0],[["meshTopoData","options","numSubdivisionBodies"],"ImportMesh",{R_:{subdivisionBodies:"Features.Subdivision.SubdivisionBody[]"}},2,0],[["subdivisionBody","options"],"ExportMesh",{R_:{meshTopoData:"SubdivisionMeshBodyTopologyData"}},2,0]],[]];
SPLM.Features.Subdivision.SubdivisionMeshExchange = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.Subdivision.SubdivisionMeshExchange";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Subdivision.SubdivisionMeshExchange.ImportOptions = class{
    constructor(part,unit,createSingleFeature,mergeSubdivisionBodyFacesIfPossible){
        this.part=part;this.unit=unit;this.createSingleFeature=createSingleFeature;this.mergeSubdivisionBodyFacesIfPossible=mergeSubdivisionBodyFacesIfPossible;}
    get Part(){return this.part}
    set Part(val){this.part = val}
    get Unit(){return this.unit}
    set Unit(val){this.unit = val}
    get Createsinglefeature(){return this.createSingleFeature}
    set Createsinglefeature(val){this.createSingleFeature = val}
    get Mergesubdivisionbodyfacesifpossible(){return this.mergeSubdivisionBodyFacesIfPossible}
    set Mergesubdivisionbodyfacesifpossible(val){this.mergeSubdivisionBodyFacesIfPossible = val}
};

SPLM.Features.Subdivision.SubdivisionMeshExchange.ExportOptions = class{
    constructor(unit){
        this.unit=unit;}
    get Unit(){return this.unit}
    set Unit(val){this.unit = val}
};

SPLM.Features.Subdivision.SubdivisionMeshExchange.Unit = Object.freeze({
    "Default" : "Default", "Millimeter" : "Millimeter", "Inch" : "Inch", "Meter" : "Meter", "Centimeter" : "Centimeter", "Foot" : "Foot", "Micrometer" : "Micrometer"});

export default SPLM;